module.exports = __webpack_public_path__ + "static/img/05_lxh.c32b316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/firstLine/05_lxh.png
// module id = U9an
// module chunks = 0